module.exports = __webpack_public_path__ + "img/bg7small.a526c9ee.jpg";